import React from 'react';
import * as Sentry from "@sentry/react";
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';

function TelaDeErro() {
  return (
    <Container className="text-center mb-5">
      <h1 className="mt-5">Algo deu errado</h1>
      <p>Recarregue a página para continuar.</p>
      <Button onClick={() => window.location.reload()}>Recarregar</Button>
    </Container>
  );
}

function ProtegeErro({ children }) {
  return (
    <Sentry.ErrorBoundary fallback={<TelaDeErro />}>
      {children}
    </Sentry.ErrorBoundary>
  );
}

export default ProtegeErro;
